import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios';
Vue.use(Vuex)

import {
	getUserInfo,
	getAddicted
} from '@/utils/api'
import {
	jsonp
} from '@/utils/requset.js'
import StorageUtils from '@/utils/StorageUtils';

export default new Vuex.Store({
	state: {
		user: {},
		token: '',
		selfType: {
			endTime: 0,
			status: '',
			show: false,
		},
		currentRoute: null,
		currentCountry:{
			country_name:'Nigeria',
			timezone: 'Africa/Lagos'
		}
	},
	getters: {
		user: state => state.user,
		currentRoute: state => state.currentRoute
	},
	mutations: {
		SET_CURRENT_ROUTE(state, route) {
            state.currentRoute = route;
        },
		SET_USER: (state, user) => {
			state.user = user
			// storage.set(constant.user, user)
		},
		SET_Token: (state, token) => {
			state.token = token
		},
		SET_SELFTYPE: (state, type) => {
			state.selfType.status = type.status
			state.selfType.endTime = type.endTime
		},
		SET_SELFTSHOW: (state, show) => {
			state.selfType.show = show
		},
		SET_CURRENTCOUNTRY: (state, country) => {
			state.currentCountry = country
		},
	},
	actions: {
		updateCurrentRoute({ commit }, route) {
            commit('SET_CURRENT_ROUTE', route);
        },
		// 设置用户信息
		SetInfo({
			commit,
			state
		}, params) {
			return new Promise((resolve, reject) => {
				commit('SET_USER', params)
			})
		},
		// 获取用户信息
		GetInfo({
			commit,
			state
		}, params) {
			return new Promise((resolve, reject) => {
				getUserInfo(params).then((res) => {
					if (res.data) {
						commit('SET_USER', res.data)
						commit('SET_USER', res.data)
					} else {
						commit('SET_USER', ['ROLE_DEFAULT'])
					}
					resolve(res)
				}).catch(error => {
					reject(error)
				})
			})
		},
		async GetIPInfo({ commit }) {
			try {
				const response = await fetch('https://ipapi.co/json/');
				const data = await response.json();
				commit('SET_CURRENTCOUNTRY', data);
			} catch (error) {
				console.error('Error fetching user info:', error);
			}
		},
		GetToken({
			commit,
			state
		}) {
			commit('SET_Token', StorageUtils.getStringData("token"))
		},
		GetSelfType({
			commit,
			state
		}, params) {
			return new Promise((resolve, reject) => {
				getAddicted(params).then((res) => {
					commit('SET_SELFTYPE', res.data)
					resolve(res)
				}).catch(error => {
					reject(error)
				})
			})
		},
		// 设置提示框是否显示
		setSelfShow({
			commit,
			state,
		}, show) {
			commit('SET_SELFTSHOW', show)
		},


		// 退出系统
		LogOut({
			commit,
			state
		}) {
			return new Promise((resolve, reject) => {
				commit('SET_USER', {})
				// 清除本地缓存

			})
		}
	},
	modules: {}
})